module.exports = __webpack_public_path__ + "img/mc_symbol.5dbb0a4c.svg";